import { CalendarCheck, Home, Hourglass, Wallet, Star, ArrowRight } from "lucide-react";
import { BRL, fmtDate } from "./ui";

const Kpi = ({ icon: Icon, label, value, tone, testId }) => (
  <div className="bg-white rounded-3xl border border-[#EDE6DA] p-5 flex flex-col gap-3" data-testid={testId}>
    <div className={`h-10 w-10 rounded-2xl flex items-center justify-center ${tone}`}><Icon size={18} /></div>
    <div>
      <div className="text-2xl sm:text-3xl font-extrabold text-slate-900 leading-none">{value}</div>
      <div className="text-xs text-slate-500 font-semibold mt-1.5">{label}</div>
    </div>
  </div>
);

export const OverviewSection = ({ user, properties, bookings, reviews }) => {
  const confirmed = bookings.filter((b) => b.status === "confirmada");
  const pending = bookings.filter((b) => b.status === "pendente");
  const received = confirmed.reduce((a, b) => a + Number(b.deposit_amount || 0), 0);
  const today = new Date().toISOString().slice(0, 10);
  const upcoming = confirmed.filter((b) => b.checkout >= today).sort((a, b) => a.checkin.localeCompare(b.checkin)).slice(0, 4);
  const avg = reviews.length ? reviews.reduce((a, r) => a + r.rating, 0) / reviews.length : 0;
  const hour = new Date().getHours();
  const hello = hour < 12 ? "Bom dia" : hour < 18 ? "Boa tarde" : "Boa noite";

  return (
    <section id="inicio" className="scroll-mt-24 space-y-5" data-testid="overview-section">
      <div className="rounded-[28px] bg-[#0A66C2] text-white p-6 sm:p-8 relative overflow-hidden">
        <div className="absolute -right-10 -top-16 w-56 h-56 rounded-full bg-[#FFCC00]/30 blur-2xl" />
        <p className="text-blue-100 text-sm font-semibold">{hello}{user?.name ? `, ${user.name}` : ""}</p>
        <h1 className="text-3xl sm:text-4xl font-bold mt-1 relative" style={{ fontFamily: "Fraunces, serif" }}>
          {pending.length > 0 ? `${pending.length} reserva(s) aguardando PIX` : "Tudo em dia por aqui"}
        </h1>
        <p className="text-blue-100 text-sm mt-2 relative">{properties.filter((p) => p.active).length} imóveis no ar · nota média {avg ? avg.toFixed(1) : "—"}</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
        <Kpi testId="kpi-received" icon={Wallet} label="Recebido em sinais" value={BRL(received)} tone="bg-emerald-100 text-emerald-700" />
        <Kpi testId="kpi-confirmed" icon={CalendarCheck} label="Reservas confirmadas" value={confirmed.length} tone="bg-blue-100 text-[#0A66C2]" />
        <Kpi testId="kpi-pending" icon={Hourglass} label="Aguardando PIX" value={pending.length} tone="bg-amber-100 text-amber-700" />
        <Kpi testId="kpi-properties" icon={Home} label="Imóveis ativos" value={`${properties.filter((p) => p.active).length}/${properties.length}`} tone="bg-orange-100 text-orange-700" />
      </div>
      <div className="bg-white rounded-3xl border border-[#EDE6DA] p-5" data-testid="upcoming-checkins">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-bold text-slate-900">Próximos check-ins</h3>
          <a href="#reservas" className="text-xs font-bold text-[#0A66C2] flex items-center gap-1">Ver todas <ArrowRight size={12} /></a>
        </div>
        {upcoming.length === 0 ? (
          <p className="text-sm text-slate-500 py-4">Nenhum check-in confirmado pela frente.</p>
        ) : (
          <ul className="divide-y divide-slate-100">
            {upcoming.map((b) => (
              <li key={b.id} className="py-3 flex items-center gap-3">
                <div className="w-12 text-center shrink-0">
                  <div className="text-lg font-extrabold text-[#0A66C2] leading-none">{b.checkin.slice(8, 10)}</div>
                  <div className="text-[10px] uppercase text-slate-400 font-bold">{fmtDate(b.checkin).slice(3)}</div>
                </div>
                <div className="min-w-0 flex-1">
                  <div className="font-semibold text-slate-800 text-sm truncate">{b.guest_name}</div>
                  <div className="text-xs text-slate-500 truncate">{b.property_title} · {b.nights} noite(s)</div>
                </div>
                <Star size={14} className="text-[#FFCC00] fill-[#FFCC00] shrink-0" />
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  );
};
